import { Model as r } from "../../../../model.js";
var e = /* @__PURE__ */ ((s) => (s[s.SHOP = 1] = "SHOP", s[s.TOTEM = 3] = "TOTEM", s))(e || {});
class T extends r {
  constructor(t) {
    super(), this.design = t.design, this.settings = t.settings;
  }
}
export {
  e as KioskConfigurationHomeMode,
  T as KioskConfigurationHomeModel
};
//# sourceMappingURL=kioskConfigurationHome.model.js.map
